import styled from 'styled-components'

export const CopyButton = styled.button`
  font-family: 'Roboto Mono', sans-serif;
  text-decoration: underline;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #FCF8F1;
  mix-blend-mode: difference;
  background-color: transparent;
  margin: 20px 0;
`;
